// ES (02.11.2026): an incoming invoice in RimoPreview's big view with its notes layer (useDocLayer) – escompte box and
// „Payée“ stamp. The original PDF is shown unchanged; the notes lie over it and, with the right d_in edit, can be dragged,
// resized at the corner, moved with the arrow keys and set back („Zurücksetzen“). Each change is stored at once
// (PUT compta/documents/:id/layer/:item); a failure shows a toast and the stored place comes back. The bar's switch
// „Vermerke“ hides them; print/download follow it (with notes, or the original when switched off).
// Design self-built from existing elements (RimoPreview, brand mark) – on the list „nachzudesignen“ (docs/PLAN.md).
import { RimoPreview } from '@rimocore/shared/preview/RimoPreview';
import { useDocLayer } from './useDocLayer';

export function LayeredPreview({ documentId, url, title, onClose }: { documentId: string; url: string; title: string; onClose: () => void }) {
  const { overlay, layer } = useDocLayer(documentId, true);
  return <RimoPreview source={url} fileName={title} mimeType="application/pdf" onClose={onClose} overlay={overlay} layer={layer} />;
}
